module.exports = __webpack_public_path__ + "img/13g-doc-emissao-resultado.9fe02afc.png";